import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page6() {
  useEffect(() => {
    document.title = "Маяк — Страница 5"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page4" />
        <ForwardLink href="/page6" />
      </div>

      <p style={{ textAlign: "right" }}>5.</p>
      <p>Он вытаскивает набивку из конского волоса...</p>
      <p>
        Достает небольшую безделушку длиной около шести дюймов... Это<br/>
        РУСАЛКА, вырезанная из слоновой кости, с чешуей на<br/>
        хвосте. Примитивное, но красивое чучело. <i>Странное.</i>
      </p>
      <p>МОЛОДОЙ смотрит на нее с голодным любопытством...</p>
      <p>Он проводит большим пальцем по ее телу... ее груди...</p>
      <p>Он чувствует себя немного виноватым и кладет ее в карман.</p>
      <p>ЗАДЕРЖКА.</p>
      <br/>
      <p>ВНУТРИ. ЗДАНИЕ ФОГОРНА – НОЧЬ</p>
      <p>
        БЛИЗКО: Огромный паровой двигатель фогорна. Поршень<br/>
        качает, шестерни скрипят, огромный маховик вращается и вращается.
      </p>
      <p>
        КАМЕРА ОПУСКАЕТСЯ ВНИЗ К: ГОЛОДНЫЙ РОТ ПЫЛАЮЩЕЙ ПЕЧИ.<br/>
      </p>
      <p>ЛОПАТА, ПОЛНАЯ УГЛЯ, входит в кадр и разжигает пламя.</p>
      <p>Еще одна полная лопата.</p>
      <p>И еще одна.</p>
      <p>ФОГОРН РЕВЕТ МУЧИТЕЛЬНО ГРОМКО.</p>
      <p>
        БЛИЗКО, РЕВЕРСИВНО: МОЛОДОЙ забрасывает уголь в печь, истекая<br/>
        потом, дрожа от сильной жары.
      </p>
      <p>Он забрасывает снова и снова.</p>
      <p>ФОГОРН ГУДИТ: ГРОМКО. БЛИЗКО. БОЛЬНО.</p>
      <p>МОЛОДОЙ НАПРЯГАЕТСЯ, ШАТАЯСЬ ОТ ЗВУКА.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ/ПРИХОЖАЯ – НОЧЬ</p>
      <p>
        Содержимое кухонного шкафа разбросано по полу.<br/>
        СТАРИК внутри встроенного шкафа по пояс, торцом наружу.<br/>
        Если бы у него был хвост, он бы вилял им. Он что-то ищет.<br/>
        Что-то секретное.
      </p>
      <p>
        МОЛОДОЙ смотрит издали на лестнице. СТАРИК выползает<br/>
        с деревянным сундуком. Он улыбается с облегчением, вытаскивая<br/>
        БУТЫЛКУ С ЛИКЕРОМ, из морского стекла. Он дрожит немного, слишком долго он ее искал.
      </p>
      <p style={{ textAlign: "right" }}>5.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page4" />
        <ForwardLink href="/page6" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710022618/the-lighthouse-script/eiysmbbmjwh4o05jvf6p.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page6;
